module.exports = __webpack_public_path__ + "img/avatar.d5aa6d19.png";